// window.cateData.isShowLoading = true; //页面需要loading加载数据
var campaignPagenewmbModule = {
  isScrolling: false, // 是否正在滚动

  init: function () {
    this.initVue();
    this.initTab();
  },

  // 处理视频按钮点击
  handleVideoClick: function(title) {
    gioTrackAction.gio_base('mbfy26q3_kv_VideoClick', { 'mbfy22q3_kvtitle': title });
    if (!getCookie('newmb_form_submitted')) {
      window.cateData.purchaseIntentionForm.successFn = function() {
        setCookie('newmb_form_submitted', true, 1);
        filelist.video('https://dellvideo.smarket.net.cn/video/21a6479c-19928ac5b6e-0006-7737-ac3-9ea81.mp4', '驭浪者无疆-出海解决方案视频');
      };
      msg.ProjectConsultingDialog();
      $('.dialog-bargain-title').html('出海解决方案视频观看');
      $('.dialog-bargain-tip').html('请填写您的个人信息，提交成功后即可观看视频');
      return;
    }
    // 如果已提交过表单，直接播放视频
    filelist.video('https://dellvideo.smarket.net.cn/video/21a6479c-19928ac5b6e-0006-7737-ac3-9ea81.mp4', '驭浪者无疆-出海解决方案视频');
  },

  // 处理PDF按钮点击
  handlePdfClick: function(title) {
    gioTrackAction.gio_base('mbfy26q3_kv_PDFClick', { 'mbfy22q3_kvtitle': title });
    if (!getCookie('newmb_form_submitted')) {
      window.cateData.purchaseIntentionForm.successFn = function(){
        setCookie('newmb_form_submitted', true, 1);
        window.open('https://www.dellemc-solution.com/view-2505160361086224.html', '_blank');
      };
      msg.ProjectConsultingDialog();
      $('.dialog-bargain-title').html('出海解决方案白皮书下载申请单');
      $('.dialog-bargain-tip').html('请填写您的个人信息，提交成功后可下载白皮书');
      return;
    }
    // 如果已提交过表单，直接打开PDF
    window.open('https://www.dellemc-solution.com/view-2505160361086224.html', '_blank');
  },
  initVue: function () {
    new Vue({
      el: '.m-newmb-container',
      data: {
        selectNav: "企业福利",
        selectTab: "商用笔记本",
        tabList: ["商用笔记本", "专业工作站", "商用台式机", "显示器及外设", "服务器", "数据存储"],
        type: "解决方案"
      },
      methods: {
        changeTab: function (tab) {
          if (this.selectTab == tab) {
            return;
          }
          this.selectTab = tab;
        }
      },
      mounted: function () {
        var url = new URL(window.location.href);
        var posValue = url.searchParams.get('pos');
        if (posValue && posValue.includes('product_')) {
          if (posValue.includes('2107272370292460')) {
            this.selectTab = '专业工作站';
          } else if (posValue.includes('2107270899976793')) {
            this.selectTab = '商用台式机';
          } else if (posValue.includes('2505223936845935')) {
            this.selectTab = '显示器及外设';
          } else if (posValue.includes('2107274199508570')) {
            this.selectTab = '服务器';
          } else if (posValue.includes('2107202785859929')) {
            this.selectTab = '数据存储';
          } else {
            this.selectTab = '商用笔记本';
          }
          this.$nextTick(function() {
            setTimeout(function() {
              var element = document.getElementById('EnterpriseDiscountsWap');
              if (element) {
                window.scrollTo({
                  top: element.offsetTop - 100,
                  behavior: 'smooth'
                });
              }
            }, 500);
          });
        }
        gioTrackAction.gio_base('mb_abm_ProductTabClick', {
          'mbfy22q3_tabtitle': this.selectTab
        })
      }
    });
  },
  /* 滚动定位和固定Tab到顶部 */
  scrollLocate: function () {
    var _this = this;
    var header = document.querySelector('.topbar');
    var tabConBox = document.querySelector('.m-newmb-container'); // 实时获取一下元素距离顶部的距离
    var tabCon = document.querySelector('.m-tab-box'); // 实时获取一下元素距离顶部的距离
    var tabList = document.querySelectorAll('.m-tab-box a');
    var tabConTop = tabConBox.offsetTop; // 实时获取一下元素距离顶部的距离
    var oScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (oScrollTop > tabConTop) {
      tabCon.classList.add('fixed-tab');
    } else {
      tabCon.classList.remove('fixed-tab');
    }

    if (!_this.isScrolling) {
      for (var idx = 0; idx < tabList.length; idx++) {
        for (var idx = 0; idx < tabList.length; idx++) {
          tabList[idx].parentElement.classList.remove('m-tab-item-active');
          var target = document.getElementById(tabList[idx].hash.slice(1));
          if (!target) return;

          // targetTop 目标距离顶部距离，targetBottom 目标底部距离页面顶部距离
          var targetTop = target.offsetTop - 80;
          var targetBottom = target.offsetTop + target.offsetHeight - header.offsetHeight - 10;

          targetTop = targetTop - tabCon.offsetHeight;
          targetBottom = targetBottom - tabCon.offsetHeight;
          if (!tabCon.classList.contains('fixed-tab')) {
            targetTop = targetTop - 55;
          }

          // 高度容错
          targetTop -= 95;
          targetBottom -= 95;

          if (oScrollTop >= targetTop && oScrollTop < targetBottom) {
            tabList[idx].parentElement.classList.add('m-tab-item-active');
          }

        }
        // tab没有固定之前默认第一个选中
        if (!tabCon.classList.contains('fixed-tab')) {
          tabList[0].parentElement.classList.add('m-tab-item-active');
        }
      }
    }
  },
  /* 初始化Tab */
  initTab: function () {
    var _this = this;
    var header = document.querySelector('.topbar');
    var tabList = document.querySelectorAll('.m-tab-box a');
    var tabCon = document.querySelector('.m-tab-box'); // 实时获取一下元素距离顶部的距离
    for (var idx = 0; idx < tabList.length; idx++) {
      tabList[idx].index = idx;
      tabList[idx].onclick = function () {
        var target = document.getElementById(this.hash.slice(1));
        if (!target) return;
        for (var k = 0; k < tabList.length; k++) {
          tabList[k].parentElement.classList.remove('m-tab-item-active');
        }
        this.parentElement.classList.add('m-tab-item-active');

        var targetOffsetTop = target.offsetTop - header.offsetHeight - tabCon.offsetHeight;

        if (!tabCon.classList.contains('fixed-tab')) {
          targetOffsetTop = targetOffsetTop - tabCon.offsetHeight;
        }

        _this.isScrolling = true;
        campaignPagenewmbModule.isClick = true;
        $('html, body').animate({ scrollTop: targetOffsetTop }, 500, 'linear', function () {
          _this.isScrolling = false;
          campaignPagenewmbModule.isClick = false;
          campaignPagenewmbModule.scrollLocate();
        });
        return false;
      }
    }
  }
};
campaignPagenewmbModule.init();
campaignPagenewmbModule.isClick = false;
window.onscroll = function () {
  if (campaignPagenewmbModule.isClick) return;
  campaignPagenewmbModule.scrollLocate();
};
